import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderAdjustmentIncreaseItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import ProviderAdjustmentIncreaseItemsList from "components/ProviderDashboard/ProviderItems/ProviderAdjustmentIncreaseItemsList"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"

const ProviderAdjustmentIncrease = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
  }

  const ProviderAdjustmentIncreaseItems = useSelector(
    state => state.providerDashboard.ProviderAdjustmentIncreaseItems
  )

  // get adjustment increase items based params
  useEffect(() => {
    dispatch(getProviderAdjustmentIncreaseItems(getParams))

    return () => {
      dispatch(providerDashboardAction.resetProviderAdjustmentIncreaseItems())
    }
  }, [])

  return (
    // Provider Adjustment Increase Item list components
    <ProviderAdjustmentIncreaseItemsList
      data={ProviderAdjustmentIncreaseItems?.data?.data}
      loading={ProviderAdjustmentIncreaseItems?.loading}
    />
  )
}

export default ProviderAdjustmentIncrease
